<template>
  <v-card outlined class="mt-2 mb-2">
    <v-card-text>
      <v-card-title>Regras de Obrigatoriedade De Campos</v-card-title>
      <v-row>
        <v-col cols="12" xs="12">
          <v-card outlined>
            <v-card-title>Habilitar/Desabilitar Campos Obrigatórios</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="5" sm="12">
                  <soi-switch :name="'Habilitar Obrigatoriedade CPF'"
                    :label="localValue.habilitarCpf ? 'CPF obrigatório no cadastro' : 'CPF não obrigatório no cadastro'"
                    v-model="localValue.habilitarCpf" :disabled="disabled" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="5" sm="12">
                  <soi-switch :name="'Habilitar Obrigatoriedade Documento Médico'"
                    :label="localValue.habilitarDocumentoMedico ? 'Documento Médico obrigatório no cadastro' : 'Documento Médico não obrigatório no cadastro'"
                    v-model="localValue.habilitarDocumentoMedico" :disabled="disabled" />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import ModuloConfiguracaoCampos from '@/models/objetosDeValor/ModuloConfiguracaoCampos';
import { MensagemMixin } from '@/helpers/MensagemHelper';

export default Vue.extend({
  name: 'SoiModulosConfiguracaoCampos',
  props: {
    value: {
      type: Object as PropType<ModuloConfiguracaoCampos | null>,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      localValue: new ModuloConfiguracaoCampos(),
      isInitializing: true,
    };
  },
  watch: {
    value: {
      handler(newValue: ModuloConfiguracaoCampos | null) {
        if (newValue) {
          this.localValue.habilitarCpf = newValue.habilitarCpf ?? false;
          this.localValue.habilitarDocumentoMedico = newValue.habilitarDocumentoMedico ?? false;
        } else {
          this.localValue = new ModuloConfiguracaoCampos();
        }

        this.$nextTick(() => {
          this.isInitializing = false;
        });
      },
      immediate: true,
      deep: true,
    },
    'localValue.habilitarCpf': {
      handler(newVal: boolean, oldVal: boolean) {
        if (!this.isInitializing && newVal !== oldVal) {
          this.emitUpdate();
          const mensagem = newVal
            ? 'CPF habilitado como obrigatório no cadastro do paciente.'
            : 'CPF desabilitado no cadastro do paciente.';
          MensagemMixin(3000, 'success', mensagem);
        }
      },
    },
    'localValue.habilitarDocumentoMedico': {
      handler(newVal: boolean, oldVal: boolean) {
        if (!this.isInitializing && newVal !== oldVal) {
          this.emitUpdate();
          const mensagem = newVal
            ? 'Documento Médico habilitado como obrigatório no cadastro do paciente.'
            : 'Documento Médico desabilitado no cadastro do paciente.';
          MensagemMixin(3000, 'success', mensagem);
        }
      },
    },
  },
  methods: {
    emitUpdate(): void {
      this.$emit('input', { ...this.localValue });
    },
  },
});
</script>
